import { useEffect } from "react";

import { useAppContext, useAppDispatch } from "@app/helpers/hooks";
import { getTripSegmentStops } from "@app/modules/results/state/thunks/get-trip-segment-stops";

export const useFetchSegmentStopsIfNotLoaded = (
  stops_loaded: boolean,
  trip_id: string | undefined
) => {
  const { api } = useAppContext();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!stops_loaded && trip_id) {
      dispatch(
        getTripSegmentStops({
          trip_id,
          api
        })
      );
    }
  }, [dispatch, stops_loaded, trip_id, api]);
};
